export default "/assets/images/chart-sm-02.a15e34242f51df81.svg";